import { useEffect, useState } from 'react'

import './_singleSetting.scss'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'

import { Button } from 'components/Button/Button'
import InputCard from 'components/Form/InputCard/InputCard'
import { addToast } from 'components/Toast/Toast'
import { Icons } from 'helpers/icons'
import { putProfileSettings } from 'services/endpoints/settings/account/profileSettings'
import { useUserProfile } from 'store'

import { SuccessfulChange } from '../SuccessfulChange'

export const MiniBio = () => {
    const [value, setValue] = useState<string>('')
    const [originalValue, setOriginalValue] = useState<string>('')
    const [page, setPage] = useState<number>(1)

    const navigate = useNavigate()

    const userData = useUserProfile()

    const queryClient = useQueryClient()
    const { t } = useTranslation()

    const submitFunction = useMutation(
        async () => await putProfileSettings({ mini_bio: value }),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('user-profile')
                queryClient.refetchQueries(['profile', `${userData?.id}`])
                setPage(2)
            },
            onError: err => {
                console.error(err)
                addToast('error', t('error:errorSomethingWentWrong'))
            }
        }
    )

    useEffect(() => {
        if (userData) {
            const initial = userData.mini_bio || ''
            setValue(initial)
            setOriginalValue(initial)
        }
    }, [userData])

    const renderPage = () => {
        if (page === 1) {
            return (
                <>
                    <InputCard
                        hasAvatar={true}
                        type='text'
                        label={t('miniBio')}
                        value={value}
                        changeFn={(val: string) => {
                            setValue(val)
                        }}
                        hasDesc={true}
                        maxChars={30}
                        desc={`${value.trim().length} / 30 ${t('characters')}`}
                        customClass='mini-bio-input'
                    />

                    <Button
                        text={t('save')}
                        color='black'
                        font='mont-16-bold'
                        width='20'
                        height='5'
                        disabled={value === originalValue || value.trim().length > 30}
                        clickFn={() => {
                            submitFunction.mutate()
                        }}
                        customClass='mini-bio-save-button'
                    />
                </>
            )
        } else {
            return (
                <>
                    <SuccessfulChange
                        img={Icons.avatar_big}
                        text={t('successfullyUpdatedMiniBio')}
                    />
                    <Button
                        text={t('close')}
                        color='black'
                        font='mont-16-bold'
                        width='20'
                        height='5'
                        clickFn={() => {
                            navigate('/settings/general/profile-settings')
                        }}
                        customClass='mini-bio-save-button'
                    />
                </>
            )
        }
    }

    return <>{renderPage()}</>
}
